export default "__VITE_ASSET__OrN3OKwP__"